import React from "react";
import { useLang } from "../i18n/LanguageContext";

export function PageHero({ eyebrow, title, subtitle, image }) {
  const { t } = useLang();
  return (
    <section className="relative overflow-hidden">
      {image && <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url('${image}')` }} />}
      <div className="absolute inset-0 hero-overlay" />
      <div className="relative mx-auto max-w-7xl px-6 py-20 lg:px-8">
        <p className="eyebrow text-gold">{t(eyebrow)}</p>
        <h1 className="mt-3 font-serif-display text-4xl font-bold tracking-tight text-parchment sm:text-5xl lg:text-6xl">{t(title)}</h1>
        {subtitle && <p className="mt-4 max-w-2xl text-lg text-parchment/85">{t(subtitle)}</p>}
      </div>
      <div className="kente-border" />
    </section>
  );
}

export function Section({ children, className = "" }) {
  return <section className={`mx-auto max-w-7xl px-6 py-16 lg:px-8 ${className}`}>{children}</section>;
}
